'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textToHtml = undefined;

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function textToHtml(documentId, text, config) {
  var textClone = text.substr(0);
  var html = void 0;
  try {
    html = textClone.replace(/\n/mg, '<br/>').replace(/><br\s*\/?></mg, '><').replace(/\[image:(.*?)]/g, function (outer, inner) {
      return '<div class="document_image"><img src="' + config.storefront.staticUrl + '/' + config.storefront.documentsImagesPath + '/' + documentId + '/' + inner + '"/></div>';
    }).replace(/\[video:(.*?)]/g, function (outer, inner) {
      return '<div class="document_video"><img src="https://content.jwplatform.com/thumbs/' + inner + '-640.jpg"/></div>';
    }).replace(/\$(.*?)\$/g, function (outer, inner) {
      return _katex2.default.renderToString(inner, { displayMode: true, throwOnError: true });
    });
  } catch (error) {
    html = error.message;
  }

  return html;
}

exports.textToHtml = textToHtml;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Parser.js
// module id = 196
// module chunks = 0